<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Número Fiscal</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="chave_mdfe"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Chave</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Nota Fiscal Inicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Nota Fiscal Final</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="porto_origem"
              :options="optionsPorto"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Porto de Origem"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="porto_destino"
              :options="optionsPorto"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Porto de Destino"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="embarcacao"
              :options="optionsEmbarcacao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Embarcação"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="evento"
              :options="optionsLivEvento"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Evento"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status"
              :options="optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_cte_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° CTE Inicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_cte_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° CTE Final</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Emissão Inicial"
              reset-button
              v-model="dt_emi_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Emissão Fim"
              reset-button
              v-model="dt_emi_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <multiselect
              v-model="transportadora"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsTransportadora"
              track-by="value"
              label="label"
              id="transportadora"
              :hide-selected="true"
              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingTransportadora"
              @search-change="listaTransportadora"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="4" class="p-0">
            <b-container>
              <b-col sm="6" md="6">
                <b-form-checkbox
                  v-model="consulta_completa"
                  value="1"
                  unchecked-value="2"
                >
                  Consulta Completa
                  <span
                    v-b-tooltip
                    title="Se marcado irá retornar consulta completa do documento"
                    placement="top"
                    >[?]</span
                  >
                </b-form-checkbox>
              </b-col>
            </b-container>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

import { formatCNPJFromParts } from "../utils";

import moment from 'moment'
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({ params: [], search: "" }),
      num_fiscal: "",
      chave_mdfe: "",
      num_fiscal_ini: "",
      num_fiscal_fim: "",
      descr: "",
      dt_inicio_label: "",
      dt_fim_label: "",
      num_cte_fim: "",
      num_cte_ini: "",
      dt_emi_ini: "",
      dt_emi_fim: "",
      consulta_completa: "",
      optionsPorto: [],
      porto_origem: [],
      porto_destino: [],
      optionsEmbarcacao: [],
      embarcacao: [],
      optionsLivEvento: [],
      optionsTransportadora: [],
      transportadora: [],
      isLoadingTransportadora: false,
      evento: [],
      optionsLivStatus: [],
      status: [],
      data_filter: [],
    };
  },
  mounted() {
    this.getPorto();
    this.getLivEvento();
    this.getEmbarcacao();
    this.getLivStatus();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_inicio_label = this.dt_emi_ini;
      this.dt_fim_label = this.dt_emi_fim;
      this.dt_emi_ini = this.formatDateSubmit(this.dt_emi_ini);
      this.dt_emi_fim = this.formatDateSubmit(this.dt_emi_fim);
      this.data_filter = {
        num_fiscal: this.num_fiscal,
        chave_mdfe: this.chave_mdfe,
        num_fiscal_ini: this.num_fiscal_ini,
        num_fiscal_fim: this.num_fiscal_fim,
        evento: this.evento,
        dt_emi_ini: this.dt_emi_ini,
        dt_emi_fim: this.dt_emi_fim,
        num_cte_ini: this.num_cte_ini,
        num_cte_fim: this.num_cte_fim,
        porto_origem: this.porto_origem,
        porto_destino: this.porto_destino,
        consulta_completa: this.consulta_completa,
        embarcacao: this.embarcacao,
        status: this.status,
        transportadora: this.transportadora,
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_emi_ini = this.dt_inicio_label;
      this.dt_emi_fim = this.dt_fim_label;
    },
    resetFilter() {
      this.num_fiscal = ""; // clear the text in text input
      this.evento = "";
      this.dt_emi_ini = "";
      this.dt_emi_fim = "";
      this.num_cte_ini = "";
      this.num_cte_fim = "";
      this.chave_mdfe = "";
      this.num_fiscal_ini = "";
      this.num_fiscal_fim = "";
      this.porto_origem = "";
      this.porto_destino = "";
      this.consulta_completa = "";
      this.embarcacao = "";
      this.status = "";
      this.transportadora = "";
      this.$events.fire("filter-reset");
    },
    getPorto() {
      this.helpForm
        .get("/api/porto/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach((obj) => {
            this.optionsPorto.push({ label: obj.cd, value: obj.cd });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false);
        });
    },
    getEmbarcacao() {
      this.helpForm
        .get("/api/embarcacao/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach((obj) => {
            this.optionsEmbarcacao.push({ label: obj.nome, value: obj.irin });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false);
        });
    },
    getLivEvento() {
      this.helpForm.params = {
        tabela: "manifesto_evento",
        coluna: "tp_evento",
      };

      this.helpForm
        .get("/api/listitemvalor/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach((obj) => {
            this.optionsLivEvento.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivStatus() {
      this.helpForm.params = { tabela: "manifesto", coluna: "status" };

      this.helpForm
        .get("/api/listitemvalor/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.items.forEach((obj) => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>